export default "__VITE_ASSET__CIgc98EH__"